import React from 'react'
import CSSTransition from 'react-transition-group/CSSTransition'

import Card from '@cinch/oxd-components/card/src'
import Portal from '@cinch/oxd-components/portal/src'

import * as baseStyles from './modal.module.css'

export interface ModalProps {
  children?: React.ReactNode
  title?: string | React.ReactNode
  cardStyles?: any
  styles?: any
  closeText?: string
  onClose?: (e: any) => void
}

const TIMEOUT = 250

class Modal extends React.Component<ModalProps, { mounted: boolean }> {
  public state = { mounted: false }

  public componentDidMount(): void {
    this.setState({ mounted: true })
    document.addEventListener('keydown', this.onKeyDown, false)
  }

  public componentWillUnmount(): void {
    document.removeEventListener('keydown', this.onKeyDown, false)
  }

  public close = () => {
    this.setState({ mounted: false })
  }

  public onBackdropClick = (event: React.TouchEvent | React.MouseEvent) => {
    const { id } = event.target as HTMLDivElement
    if (id === 'backdrop') {
      this.close()
    }
  }

  public onKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      this.close()
    }
  }

  public render() {
    const { children, title, cardStyles, styles, closeText } = this.props

    const classNames = {
      ...baseStyles,
      ...(styles || {}),
    }

    const backdropClassNames = {
      enter: classNames.backdropEnter,
      enterActive: classNames.backdropEnterActive,
      exit: classNames.backdropExit,
      exitActive: classNames.backdropExitActive,
    }

    const modalClassNames = {
      enter: classNames.modalEnter,
      enterActive: classNames.modalEnterActive,
      exit: classNames.modalExit,
      exitActive: classNames.modalExitActive,
    }

    return (
      <Portal>
        <CSSTransition
          appear={true}
          classNames={backdropClassNames}
          unmountOnExit={true}
          timeout={TIMEOUT}
          in={this.state.mounted}
          onExited={this.props.onClose}
        >
          {(state: string) => (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events
            <div id="backdrop" role="presentation" className={classNames.backdrop} onClick={this.onBackdropClick}>
              <CSSTransition
                appear={true}
                classNames={modalClassNames}
                unmountOnExit={true}
                timeout={TIMEOUT}
                in={state === 'entered'}
              >
                <div className={classNames.modal} role="dialog" aria-modal="true">
                  <Card title={title} cardStyles={cardStyles} onClose={this.close} closeText={closeText}>
                    {children}
                  </Card>
                </div>
              </CSSTransition>
            </div>
          )}
        </CSSTransition>
      </Portal>
    )
  }
}

export default Modal
